import React, { useEffect, useRef } from 'react';
import { Box, Container, Fade } from '@mui/material';
import { useManualLoginForm } from '../hooks/pages/manualLogin/useManualLoginForm';
import PromotionalSection from '../components/auth/PromotionalSection';
import MicrosoftLoginButton from '../components/auth/MicrosoftLoginButton';
import EmailDivider from '../components/auth/EmailDivider';
import LoginHeader from '../components/auth/manualLogin/LoginHeader';
import ErrorAlert from '../components/auth/manualLogin/ErrorAlert';
import LoginFormFields from '../components/auth/manualLogin/LoginFormFields';
import LoginButton from '../components/auth/manualLogin/LoginButton';
import {
  containerStyles,
  leftColumnStyles,
  containerInnerStyles,
  formContainerStyles,
  formStyles,
  ANIMATION_TIMEOUTS,
} from '../constants/manualLogin';

const ManualLogin = () => {
  const {
    formData,
    error,
    loading,
    showPassword,
    handleChange,
    handleRememberMeChange,
    togglePasswordVisibility,
    handleSubmit,
  } = useManualLoginForm();

  const emailInputRef = useRef(null);

  useEffect(() => {
    if (emailInputRef.current) {
      emailInputRef.current.focus();
    }
  }, []);

  const handleMicrosoftLogin = () => {
    // TODO: Implement Microsoft OAuth
  };

  return (
    <Box sx={containerStyles}>
      {/* Left Column - Login Form */}
      <Box sx={leftColumnStyles}>
        <Container maxWidth="sm" sx={containerInnerStyles}>
          <Fade in={true} timeout={ANIMATION_TIMEOUTS.FADE_IN}>
            <Box sx={formContainerStyles}>
              <LoginHeader />

              <ErrorAlert error={error} />

              {/* Form */}
              <Box component="form" onSubmit={handleSubmit} sx={formStyles}>
                <LoginFormFields
                  formData={formData}
                  showPassword={showPassword}
                  loading={loading}
                  emailInputRef={emailInputRef}
                  onChange={handleChange}
                  onTogglePassword={togglePasswordVisibility}
                  onRememberMeChange={handleRememberMeChange}
                />

                <LoginButton loading={loading} />
              </Box>

              {/* Dividers
              <EmailDivider text="Or" /> */}

              {/* Microsoft Login Button */}
              {/* <MicrosoftLoginButton onClick={handleMicrosoftLogin} /> */}
            </Box>
          </Fade>
        </Container>
      </Box>

      {/* Right Column - Promotional Section */}
      <PromotionalSection />
    </Box>
  );
};

export default ManualLogin;
